import { RouteEntry } from "../../shared/routes";
import { GrowList } from "./growList";



export const growRoutes: Array<RouteEntry> = [
    { path: '/grow', element: <GrowList />, authorize: true, }
];